
export const transform = ({
							  id,
							  name,
							  parent,
							  timeframe
}) => (
	{
		id: id,
		name: name,
		parent: parent,
		timeframe: timeframe,
	}
);
